/* Header anchor scroll — let the main header's nav links jump to on-page
   sections (e.g. the PDP content sections), offset below the sticky header.
   Works for same-page links and after cross-page navigation (via the URL hash).
   Targets are resolved flexibly: a plain element id, the Shopify section
   wrapper id (shopify-section-<id>), the section's data-section-id, or just the
   section key suffix (__<key>) — so menu links like "#pdp_formula" or
   "/products/handle#pdp_formula" both work. */
(function () {
  function resolveTarget(hash) {
    var id = (hash || "").replace(/^#/, "");
    if (!id) return null;
    return (
      document.getElementById(id) ||
      document.getElementById("shopify-section-" + id) ||
      document.querySelector('[data-section-id="' + id + '"]') ||
      document.querySelector('[data-section-id$="__' + id + '"]')
    );
  }

  function headerOffset() {
    var header = document.querySelector(".wt-header");
    return header ? header.getBoundingClientRect().height : 0;
  }

  function scrollToEl(el) {
    var top =
      el.getBoundingClientRect().top + window.scrollY - headerOffset() - 8;
    window.scrollTo({ top: top, behavior: "smooth" });
  }

  // Same-page nav links → smooth scroll (let cross-page links navigate normally).
  // Broad selector (any anchor with a hash) + capture phase so this runs before
  // the mega-menu's own click handlers can swallow the event. It only acts when
  // the hash actually resolves to a section, so other "#" links are unaffected.
  function onClick(event) {
    var link = event.target.closest('a[href*="#"]');
    if (!link) return;
    var url;
    try {
      url = new URL(link.href, window.location.href);
    } catch (e) {
      return;
    }
    if (!url.hash || url.pathname !== window.location.pathname) return;
    var target = resolveTarget(url.hash);
    if (!target) return;
    event.preventDefault();
    scrollToEl(target);
    if (history.replaceState) history.replaceState(null, "", url.hash);
  }
  document.addEventListener("click", onClick, true);

  // Arriving with a hash (e.g. navigated here from another page) → scroll to it.
  window.addEventListener("load", function () {
    if (!window.location.hash) return;
    var target = resolveTarget(window.location.hash);
    if (target) {
      setTimeout(function () {
        scrollToEl(target);
      }, 250);
    }
  });
})();
